import { Stack, Box, Typography } from "@mui/material";
import { IconNF } from "../../Icons/IconNF";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import moment from "moment";
import { moneyFormat } from "utils/Masks/Masks";
import TicketService from "services/ticket";

export default function CardFinance({ ticket, onClick }) {
    const dataFormated = moment(ticket["dt-emis-nota"], "YYYY-MM-DD")
        .locale("pt-br")
        .format("MMMM/YYYY");

    const ticketStatus = TicketService.getTicketStatus(ticket);

    const bgColor =
        ticketStatus === "avencer" || ticketStatus === "open"
            ? "#FF9703"
            : ticketStatus === "paid"
            ? "#00A326"
            : ticketStatus === "outdated"
            ? "#EA4C4B"
            : "#A2A2A2";

    return (
        <Box
            sx={{
                borderRadius: "8px",
                border: "2px solid #053462",
                width: "98%",
                minHeight: "160px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "stretch",
                marginBottom: "24px",
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                cursor: "pointer",
            }}
            onClick={onClick}
        >
            <Stack
                width={"22%"}
                justifyContent={"center"}
                alignItems={"center"}
            >
                <Stack
                    justifyContent="center"
                    alignItems="center"
                    bgcolor={bgColor}
                    borderRadius="8px"
                    padding="8px"
                    width="70%"
                >
                    <IconNF strokeColor={bgColor} />
                    <Typography
                        fontSize="11px"
                        fontWeight={600}
                        color="#FFFFFF"
                    >
                        Nota fiscal{" "}
                        {ticketStatus === "avencer" ||
                        ticketStatus === "open" ? (
                            "a vencer"
                        ) : ticketStatus === "paid" ? (
                            "paga"
                        ) : ticketStatus === "outdated" ? (
                            "vencida"
                        ) : (
                            <>
                                cancelada/
                                <br />
                                devolvida
                            </>
                        )}
                    </Typography>
                </Stack>
            </Stack>

            <Stack
                direction="column"
                justifyContent="center"
                spacing={1}
                sx={{
                    flex: 1,
                    paddingX: 2,
                    overflow: "hidden",
                    textAlign: "left",
                }}
            >
                <Stack>
                    <Typography
                        fontSize="16px"
                        fontWeight={600}
                        color="#636363"
                    >
                        Endereço
                    </Typography>
                    <Typography
                        fontSize="24px"
                        fontWeight={600}
                        color="#053462"
                        sx={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                        }}
                    >
                        {ticket["endereco"]}
                    </Typography>
                </Stack>

                <Stack direction="row" gap={2}>
                    <Stack>
                        <Typography
                            fontSize="14px"
                            fontWeight={600}
                            color="#636363"
                        >
                            Número da nota fiscal
                        </Typography>
                        <Typography
                            fontSize="20px"
                            fontWeight={600}
                            color="#053462"
                        >
                            {ticket["nr-nota-fis"]}
                        </Typography>
                    </Stack>

                    <Stack>
                        <Typography
                            fontSize="14px"
                            fontWeight={600}
                            color="#636363"
                        >
                            {dataFormated.charAt(0).toUpperCase() +
                                dataFormated.slice(1)}
                        </Typography>

                        <Typography
                            fontSize="20px"
                            fontWeight={600}
                            color="#053462"
                        >
                            {moneyFormat(ticket["vl-tot-nota"])}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>

            <Stack
                bgcolor={bgColor}
                justifyContent="center"
                alignItems="center"
                width="10%"
            >
                <ArrowForwardIcon
                    sx={{ color: "#FFFFFF", width: 30, height: 30 }}
                />
                <Typography fontSize="11px" fontWeight={700} color="#FFFFFF">
                    Ver mais
                </Typography>
            </Stack>
        </Box>
    );
}
